import BlockIcon from '@mui/icons-material/Block';
import IconType from '../../InputComponents/IconType';
import { EDropCategory } from '../../../data/Constants';

import type { ICategoryDragData } from '../../../../types/ICategoryTypes';

interface ICategoryDragOverlayProps {
  activeData?: ICategoryDragData;
  activeId: string | null;
  showForbidden: boolean;
}

export const CategoryDragOverlay: React.FC<ICategoryDragOverlayProps> = ({
  activeData,
  activeId,
  showForbidden,
}) => {
  if (!activeId) {
    return null;
  }

  return (
    <div className="drag-overlay-content">
      {activeData?.type === EDropCategory.Category ? (
        <>
          <IconType type={activeData?.itemType ?? ''} />
          <span className="category-name">{activeData?.itemName || activeId}</span>
          {showForbidden && (
            <BlockIcon style={{ color: '#d32f2f', marginLeft: 8 }} fontSize="small" />
          )}
        </>
      ) : (
        <>
          <IconType type={activeData?.itemType ?? ''} />
          <div className="item-name">{activeData?.itemName || ''}</div>
          {activeData?.itemCode && <div className="item-code">({activeData.itemCode})</div>}
        </>
      )}
    </div>
  );
};
